var _defs, _title, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNoGenderUser = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 339.82 421.23",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffebd2;}"))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "no-gender-user")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M343.61,377.58a45.68,45.68,0,0,1-38.35-20.81c-8.25-12.67-7.33-23.75-7.33-32.33l-.17-.41.05,0a109.51,109.51,0,0,1-83.57,0h0l-.17.41c0,8.83.85,19.76-7.33,32.33a45.68,45.68,0,0,1-38.35,20.81,82.29,82.29,0,0,0-82.3,82.28v43.31A8.83,8.83,0,0,0,94.92,512H417.08a8.83,8.83,0,0,0,8.83-8.83V459.86A82.29,82.29,0,0,0,343.61,377.58Z",
    transform: "translate(-86.09 -90.77)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.93,326.44l-.17-.41a109.45,109.45,0,0,1-83.52,0l-.17.41c0,7.89.25,11.91-1.24,18.11a109.51,109.51,0,0,0,86.34,0C297.68,338.35,297.93,334.33,297.93,326.44Z",
    transform: "translate(-86.09 -90.77)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.17,342.55a109.51,109.51,0,0,1-86.34,0c1.49-6.2,1.24-10.22,1.24-18.11l.17-.41a109.45,109.45,0,0,0,83.52,0l.17.41C297.93,332.33,297.68,336.35,299.17,342.55Z",
    transform: "translate(-86.09 -90.77)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.22,203h0c0,.15,0,.3,0,.45Z",
    transform: "translate(-86.09 -90.77)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.22,203C365,134.74,312.69,90.77,256,90.77A109.23,109.23,0,0,0,146.77,200H147v18.29c0,69,52.31,113.53,109,113.53,60.17,0,109-49.25,109-110V203Z",
    transform: "translate(-86.09 -90.77)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNoGenderUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/no-gender-user.678b1ebc.svg";
export { ForwardRef as ReactComponent };